import { Response } from 'api/typegen/client/application/put';
import fetchWebApi from 'api/fetchWebApi';

const putLoanApplicationApiCall = async (): Promise<Response> =>
  fetchWebApi('/client/application', undefined, {
    method: 'put',
  });

export default putLoanApplicationApiCall;
